import type { LegalConsentProps } from '@paypalcorp/pp-react-checkbox-weasley-v7';
import { LegalConsent as LegalConsentBase } from '@paypalcorp/pp-react-checkbox-weasley-v7';
import { Checkbox as CheckboxBase } from '@paypalcorp/pp-react-checkbox-weasley-v7';
import styled from '@emotion/styled';
import {
  REBRAND_ERROR_COLOR,
  REBRAND_T1_PRIMARY_COLOR,
  REBRAND_T1_PRIMARY_INPUT_BORDER,
  REBRAND_T1_SELECTION_COLOR,
} from '@/styles/styleVariables';

type LS = {
  customStyle?: string;
};
export const LegalConsent = styled(LegalConsentBase)<LegalConsentProps & LS>`
  label > span > span {
    font-size: ${({ customStyle }) =>
      customStyle === 'ForcedGuestStyles' ? '18px' : '14px'};
    line-height: ${({ customStyle }) =>
      customStyle === 'ForcedGuestStyles' ? '24px' : '20px'};
    color: ${({ customStyle }) =>
      customStyle === 'ForcedGuestStyles' ? '#001435' : 'rgb(84, 93, 104)'};
  }
`;

const getBorderColor = (checked: boolean, error: boolean) => {
  if (error) {
    return REBRAND_ERROR_COLOR;
  }
  return checked ? REBRAND_T1_PRIMARY_COLOR : REBRAND_T1_PRIMARY_INPUT_BORDER;
};
/* stylelint-disable declaration-no-important */
export const CheckboxV8 = styled(CheckboxBase)`
  & > input + label > span > span:first-child {
    border-color: ${({ checked, error }) =>
      getBorderColor(Boolean(checked), Boolean(error))} !important;

    /* Updates the checkbox background to black when the checkbox is checked */
    ${({ checked }) =>
      checked &&
      `
      background-color: ${REBRAND_T1_PRIMARY_COLOR} !important;
    `}
    /* Border color is controlled elsewhere, we only need to update style and width here */
    ${({ error }) =>
      error &&
      `
      border-width: 2px !important;
      border-style: solid !important;
    `}
    /* Focus styles */
    &::after {
      box-shadow: none !important;
      outline: 0.125rem solid ${REBRAND_T1_SELECTION_COLOR} !important;
      outline-offset: 2px;
      border: none !important;
    }
  }
`;
type LegalConsentV8Props = LegalConsentProps & { error?: string };
export const LegalConsentV8 = styled(LegalConsent)<LegalConsentV8Props>`
  /* Main color changes */
  & > input + label > span > span:first-child {
    border-color: ${({ checked, error }) =>
      getBorderColor(Boolean(checked), Boolean(error))} !important;

    /* Updates the checkbox background to black when the checkbox is checked */
    ${({ checked }) =>
      checked &&
      `
      background-color: ${REBRAND_T1_PRIMARY_COLOR} !important;
    `}
    /* Background color is controlled elsewhere, we only need to update style and width here */
    ${({ error }) =>
      error &&
      `
      border-width: 2px !important;
      border-style: solid !important;
      &::after {
        left: -.125rem !important;
        top: -.125rem !important;
      }
    `}
    /* Focus styles */
    &::after {
      box-shadow: none !important;
      outline: 0.125rem solid ${REBRAND_T1_SELECTION_COLOR} !important;
      outline-offset: 2px;
      border: none !important;
    }
  }
`;
/* stylelint-enable declaration-no-important */
